import { ShieldCheck, Clock3, Camera, BadgeCheck, Headphones, Route } from "lucide-react";

const ITEMS = [
  {
    icon: Clock3,
    title: "24 / 7 dispatch",
    body: "Day, night, weekend, bank holiday — someone always picks up the phone.",
  },
  {
    icon: ShieldCheck,
    title: "Goods-in-transit insured",
    body: "Comprehensive cover for vehicles in our care, with documentation provided.",
  },
  {
    icon: Camera,
    title: "Photo-documented handover",
    body: "Condition photos taken before loading and after delivery. Total transparency.",
  },
  {
    icon: BadgeCheck,
    title: "Prestige specialists",
    body: "Supercars, classics, low-rides — soft straps, wheel nets, careful loading angles.",
  },
  {
    icon: Headphones,
    title: "Single point of contact",
    body: "You speak directly with the driver. No call-centre runaround.",
  },
  {
    icon: Route,
    title: "UK + Europe routes",
    body: "Burton-based, Midlands focused. Confident operating across the continent.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
              <span className="w-8 h-px bg-[#E60000]" />
              Why MHJ · 03
            </div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.0]">
              No drama.
              <br />
              Just the job,
              <br />
              <span className="text-stroke">done right.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-12">
            <p className="text-zinc-400 text-base lg:text-lg leading-relaxed max-w-2xl">
              You shouldn’t have to worry about the truck. Owner-operated,
              high-touch, and built around the simple promise that your
              vehicle arrives in the exact state it left in.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="bg-[#050505] p-8 lg:p-10 group hover:bg-[#0F0F0F] transition-colors"
              >
                <div className="flex items-center justify-between mb-8">
                  <div className="text-zinc-600 font-display text-2xl font-bold">
                    0{i + 1}
                  </div>
                  <Icon
                    className="w-6 h-6 text-[#E60000] group-hover:scale-110 transition-transform"
                    strokeWidth={1.6}
                  />
                </div>
                <h3 className="font-display text-white text-xl lg:text-2xl font-bold tracking-tight">
                  {item.title}
                </h3>
                <p className="mt-3 text-zinc-400 text-sm lg:text-base leading-relaxed">
                  {item.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
